import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['destinationInput']

  updateDestination(event) {
    this.destinationInputTarget.value = event.target.value
  }
}
